var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFaradayLogo(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 131 28",
    style: {
      enableBackground: "new 0 0 131 28"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#0082ED;}\r\n\t.st1{fill:#0B2633;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "9.5,10.4 3.1,10.4 2.2,16.7 8.5,16.7  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "10.4,4.1 4.1,4.1 3.1,10.4 9.5,10.4  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "8,19.9 1.7,19.9 0.8,26.2 7.1,26.2  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "9,13.6 2.7,13.6 1.7,19.9 8,19.9  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "9.9,7.3 3.6,7.3 2.7,13.6 9,13.6  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "14,0.9 7.7,0.9 6.8,7.3 13.1,7.3  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "20.4,0.9 14,0.9 13.1,7.3 19.4,7.3  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "10.4,4.1 13.6,4.1 14,0.9 10.9,0.9  "
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "16.7,4.1 19.9,4.1 20.4,0.9 17.2,0.9  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "14,0.9 7.7,0.9 6.8,7.3 13.1,7.3  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "13.6,4.1 7.2,4.1 6.3,10.4 12.6,10.4  "
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "20.4,0.9 17.2,0.9 16.2,7.3 19.4,7.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "16.7,4.1 19.9,4.1 20.4,0.9 17.2,0.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "16.7,4.1 17.2,0.9 14,0.9 13.6,4.1  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "11.7,16.7 5.4,16.7 4.4,23.1 10.7,23.1  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "8,19.9 8.5,16.7 5.4,16.7 4.9,19.9  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "4.4,23.1 7.6,23.1 8,19.9 4.9,19.9  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "0.8,26.2 3.9,26.2 4.4,23.1 1.3,23.1  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "1.7,19.9 1.3,23.1 4.4,23.1 4.9,19.9  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "12.6,10.4 6.3,10.4 5.4,16.7 11.7,16.7  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "16.7,10.4 12.6,10.4 11.7,16.7 15.8,16.7  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "11.7,16.7 15.7,16.7 16.2,13.6 12.1,13.6  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "14.8,16.7 15.3,13.6 12.1,13.6 11.7,16.7  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "9,13.6 8.5,16.7 11.7,16.7 12.1,13.6  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "9.5,10.4 9,13.6 15.3,13.6 15.8,10.4  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "15.3,13.6 15.8,10.4 12.6,10.4 12.1,13.6  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "9.5,10.4 9,13.6 12.1,13.6 12.6,10.4  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "8,19.9 11.2,19.9 11.7,16.7 8.5,16.7  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "13.6,4.1 7.2,4.1 6.3,10.4 12.6,10.4  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "6.8,7.3 13.1,7.3 13.6,4.1 7.2,4.1  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "4.9,19.9 5.4,16.7 2.2,16.7 1.7,19.9  "
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M30.6,5.7h11.6v2.5h-8.5v5h7.7v2.5h-7.7v7h-3.2V5.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M49.7,9.1c1.2,0,2.2,0.2,3.1,0.6c0.9,0.4,1.5,1,1.9,1.7l0.1-2.1h2.8v13.4h-2.8l-0.1-2.1 c-0.8,1.6-2.5,2.3-5,2.3c-1.2,0-2.3-0.3-3.2-0.9c-1-0.6-1.8-1.4-2.3-2.5c-0.6-1.1-0.9-2.2-0.9-3.6c0-1.3,0.3-2.5,0.9-3.6 c0.6-1.1,1.3-1.9,2.3-2.5C47.5,9.4,48.5,9.1,49.7,9.1z M50.5,20.4c1.2,0,2.2-0.4,3-1.2c0.8-0.8,1.2-1.9,1.2-3.1 c0-1.2-0.4-2.3-1.2-3.1c-0.8-0.8-1.8-1.2-3-1.2c-1.2,0-2.2,0.4-3,1.2c-0.8,0.8-1.2,1.9-1.2,3.1c0,1.2,0.4,2.3,1.2,3.1 C48.3,20,49.3,20.4,50.5,20.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M60,9.3h2.8l0.1,1.8c0.6-0.8,1.3-1.3,2-1.5c0.7-0.3,1.7-0.4,3-0.4v2.5c-1.6,0-2.8,0.4-3.6,1.2 C63.4,13.7,63,14.7,63,16v6.7h-3V9.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M74.7,9.1c1.2,0,2.2,0.2,3.1,0.6c0.9,0.4,1.5,1,1.9,1.7l0.1-2.1h2.8v13.4h-2.8l-0.1-2.1 c-0.8,1.6-2.5,2.3-5,2.3c-1.2,0-2.3-0.3-3.2-0.9c-1-0.6-1.8-1.4-2.3-2.5c-0.6-1.1-0.9-2.2-0.9-3.6c0-1.3,0.3-2.5,0.9-3.6 c0.6-1.1,1.3-1.9,2.3-2.5C72.4,9.4,73.5,9.1,74.7,9.1z M75.5,20.4c1.2,0,2.2-0.4,3-1.2c0.8-0.8,1.2-1.9,1.2-3.1 c0-1.2-0.4-2.3-1.2-3.1c-0.8-0.8-1.8-1.2-3-1.2c-1.2,0-2.2,0.4-3,1.2c-0.8,0.8-1.2,1.9-1.2,3.1c0,1.2,0.4,2.3,1.2,3.1 C73.3,20,74.3,20.4,75.5,20.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M90.8,9.1c1.2,0,2.2,0.2,3.1,0.6c0.9,0.4,1.5,1,1.9,1.7v-7h3v18.3h-2.8l-0.1-2.1c-0.8,1.6-2.5,2.3-5,2.3 c-1.2,0-2.3-0.3-3.2-0.9c-1-0.6-1.8-1.4-2.3-2.5c-0.6-1.1-0.9-2.2-0.9-3.6c0-1.3,0.3-2.5,0.9-3.6c0.6-1.1,1.3-1.9,2.3-2.5 C88.5,9.4,89.6,9.1,90.8,9.1z M88.6,19.2c0.8,0.8,1.8,1.2,3,1.2c1.2,0,2.2-0.4,3-1.2c0.8-0.8,1.2-1.9,1.2-3.1 c0-1.2-0.4-2.3-1.2-3.1c-0.8-0.8-1.8-1.2-3-1.2c-1.2,0-2.2,0.4-3,1.2c-0.8,0.8-1.2,1.9-1.2,3.1C87.4,17.3,87.8,18.3,88.6,19.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M106.9,9.1c1.2,0,2.2,0.2,3.1,0.6c0.9,0.4,1.5,1,1.9,1.7l0.1-2.1h2.8v13.4H112l-0.1-2.1 c-0.8,1.6-2.5,2.3-5,2.3c-1.2,0-2.3-0.3-3.2-0.9c-1-0.6-1.8-1.4-2.3-2.5c-0.6-1.1-0.9-2.2-0.9-3.6c0-1.3,0.3-2.5,0.9-3.6 c0.6-1.1,1.3-1.9,2.3-2.5C104.6,9.4,105.7,9.1,106.9,9.1z M107.7,20.4c1.2,0,2.2-0.4,3-1.2c0.8-0.8,1.2-1.9,1.2-3.1 c0-1.2-0.4-2.3-1.2-3.1c-0.8-0.8-1.8-1.2-3-1.2c-1.2,0-2.2,0.4-3,1.2c-0.8,0.8-1.2,1.9-1.2,3.1c0,1.2,0.4,2.3,1.2,3.1 C105.5,20,106.5,20.4,107.7,20.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M126.5,9.3h3.2l-5.2,13.2c-0.7,1.7-1.6,2.8-2.7,3.6c-1.1,0.7-2.6,1-4.5,0.9l-0.2-2.2c2.3,0,3.6-0.6,3.9-1.9 l-5.2-13.6h3.3l3.7,10.9L126.5,9.3z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaradayLogo);
export default __webpack_public_path__ + "static/media/faraday_logo.128c9fc120074747ed17aced6737006e.svg";
export { ForwardRef as ReactComponent };